var _Rect, _Rect2, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
var SvgIconInfo = function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#4A1A0E",
    rx: 11.5
  })), _Rect2 || (_Rect2 = /*#__PURE__*/React.createElement(Rect, {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.5,
    stroke: "#E89200",
    rx: 11.5
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFC500",
    d: "M11.208 16.356q-.168 0-.168-.168v-5.64q0-.156.168-.156h1.584q.168 0 .168.156v5.64q0 .168-.168.168zM12 9.708q-.48 0-.756-.24-.276-.252-.276-.672v-.252q0-.432.276-.66.276-.24.756-.24.492 0 .756.24.276.228.276.66v.252q0 .42-.276.672-.264.24-.756.24"
  })));
};
export default SvgIconInfo;